import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getAdminAuthtoken } from "../utils/LocalStorageUtils";

const PublicRoute = (props) => {
  const userType = process.env.REACT_APP_USER_TYPE
  const auth = getAdminAuthtoken() 

  return (
    <Route
      render={({ location }) =>
        auth ? (
          <Redirect
            to={{ pathname: userType === 'ADMIN' ? "/admin/dashboard" : "/partner/scheme" , state: { from: location } }}
          />
        ) : (
          <props.component />
        )
      }
    />
  );
};
export default PublicRoute;
